import { takeLatest, put, all, call, race, take } from 'redux-saga/effects';

import ExperienceInsightsActions from './experience-insights-actions';
import ExperienceInsightsApi from './experience-insights-api';

function* bootstrapExperienceInsightsHandler({ payload: { experienceId } }) {
  try {
    yield put(ExperienceInsightsActions.fetchExperienceTotals(experienceId));

    // this will wait for the experience totals
    const { totalsSuccess, totalsFailure } = yield race({
      totalsFailure: take(ExperienceInsightsActions.fetchExperienceTotalsFailure.getType()),
      totalsSuccess: take(ExperienceInsightsActions.fetchExperienceTotalsSuccess.getType()),
    });

    if (totalsSuccess) yield put(ExperienceInsightsActions.bootstrapExperienceInsightsSuccess());
    if (totalsFailure)
      yield put(ExperienceInsightsActions.bootstrapExperienceInsightsFailure(totalsFailure.payload.error));
  } catch (error) {
    yield put(ExperienceInsightsActions.bootstrapExperienceInsightsFailure(error));
  }
}

/**
 *
 * @param {object} payload the experience id (experienceId), export id (exportId) the api call needs
 */
function* fetchExperienceTotalsHandler({ payload: { experienceId } }) {
  try {
    const _totals = yield call(ExperienceInsightsApi.fetchExperienceTotals, { id: experienceId });
    yield put(ExperienceInsightsActions.fetchExperienceTotalsSuccess(experienceId, _totals));
  } catch (error) {
    yield put(ExperienceInsightsActions.fetchExperienceTotalsFailure(error));
  }
}

export default function* experienceInsightsSagas() {
  yield all([
    takeLatest(ExperienceInsightsActions.bootstrapExperienceInsights.getType(), bootstrapExperienceInsightsHandler),
    takeLatest(ExperienceInsightsActions.fetchExperienceTotals.getType(), fetchExperienceTotalsHandler),
  ]);
}
